export interface RouteOption {
  id: string;
  name: string;
  subtext: string;
  destination: string;
}

export interface HourlyWeather {
  hour: number;
  temp: number;
  precipProb: number;
  weatherCode: number; // Added for hourly icons
}

export interface WeatherInfo {
  day: string;
  date: string; // e.g., "15"
  maxTemp: number;
  minTemp: number;
  avgTemp: number; // Calculated average
  condition: 'sunny' | 'cloudy' | 'rainy';
  fullDate: string;
  rawDate?: string;
  hourly: HourlyWeather[]; // Array of 24 hourly points for this specific day
}

export interface TrafficDataPoint {
  hour: number; // Hora (0-23)
  halfHour: 0 | 30; // Minutos: 0 o 30
  density: number; // 0-100 (para compatibilidad hacia atrás, usar finalDensity)
  apiDensity: number; // 0-70 - Base de sistemas de navegación (TomTom)
  registeredBoost: number; // Deprecated: no usar para altura del gráfico predictivo
  finalDensity: number; // 0-100 - Altura visual semántica calculada desde API
  registeredDensity: number; // 0-100 - Deprecated, usar finalDensity
  registeredCount: number; // Número de viajes registrados en este intervalo
  label: string; // Etiqueta para el eje X
  temp?: number;
  condition?: 'sunny' | 'cloudy' | 'rainy'; // Added for chart icons
  durationMinutes?: number; // Duración estimada en minutos (para usar cuando se mueve el slider sin llamar API)
  durationOptimisticMinutes?: number | null; // Rango optimista entregado por API
  durationPessimisticMinutes?: number | null; // Rango pesimista entregado por API
  displayLevel?: 'low' | 'medium' | 'high' | 'critical' | null; // Nivel visual semántico recomendado
  explanation?: string | null; // Explicación breve del modelo para tooltip
  trafficLevel?: 'LIGHT' | 'MODERATE' | 'HEAVY' | 'SEVERE' | null; // Nivel de tráfico (para usar cuando se mueve el slider)
}

export enum Direction {
  SANTIAGO_LITORAL = "Santiago → Litoral central",
  LITORAL_SANTIAGO = "Litoral central → Santiago"
}

export type Step =
  | 'landing'
  | 'selection'
  | 'planning'
  | 'confirmation'
  | 'how-it-works'
  | 'privacy'
  | 'terms'
  | 'profile'
  | 'my-vehicle'
  | 'services'
  | 'planned-trips'
  | 'planned-trip-detail'
  | 'trip-history'
  | 'emergency';

export interface UserProfile {
  id: string;
  full_name?: string;
  email?: string;
  created_at?: string;
  updated_at?: string;
  // Añadir otros campos del perfil según tu esquema de BD
  [key: string]: unknown;
}
